export const LOAD_CONFIGURATION_SUCCESS = "@loadConfiguration/success";
export const LOAD_CONFIGURATION_FAILED = "@loadConfiguration/failed";

export const IS_FETCHING = "@isFetchingConfiguration";

export const ADD_DEPARTMENTS = "@addDepartments";
